import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
}
export function CTAButton({
  children,
  className = ''
}: CTAButtonProps) {
  return <motion.a href="https://pay.hotmart.com/Y104754180A" whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} animate={{
    boxShadow: ['0px 0px 0px rgba(74,93,58,0)', '0px 0px 20px rgba(74,93,58,0.4)', '0px 0px 0px rgba(74,93,58,0)']
  }} transition={{
    boxShadow: {
      repeat: Infinity,
      duration: 2.5,
      ease: 'easeInOut'
    },
    scale: {
      duration: 0.2
    }
  }} className={`block w-full max-w-lg mx-auto text-center bg-[#4A5D3A] text-[#FAF6F0] font-bold py-5 px-8 rounded-xl shadow-lg hover:bg-[#3a4a2e] transition-colors text-lg md:text-xl ${className}`} data-id="element-211">
      {children}
    </motion.a>;
}